import i18next from 'i18next';

import { deleteSegment } from 'common/api/v1/segmentsLayout';
import {
    POLYGON_OBSTACLE,
    POLYGON_SEGMENT,
} from 'common/components/segment/constants';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    DELETE_SEGMENT_FAILURE,
    DELETE_SEGMENT_SUCCESS,
    DELETE_SEGMENT,
    FETCH_OFFER_PANELS_SUCCESS,
} from '../actionTypes';
import { getCollidedPolygons } from '../helpers';
import { panelLayoutV2Actions } from '../reducer';
import * as selectors from '../selectors';

import checkSegment from './checkSegment';
import updateSegments from './updateSegments';

export default (
        callback,
        commercialOfferId,
        id,
        google,
        mapValue,
        checkCallback,
        checkCallbackError,
    ) =>
    (dispatch, getState) => {
        const state = getState();
        const segments = selectors.getSegmentsData(state);
        const segment = segments.filter((segment) => segment.id === id);
        let prevCollidedPolygons = [];

        dispatch(panelLayoutV2Actions[DELETE_SEGMENT]());

        if (segment[0].type === POLYGON_OBSTACLE) {
            const polygons = segments.filter(
                (segment) => segment.type === POLYGON_SEGMENT,
            );

            prevCollidedPolygons = getCollidedPolygons({
                points: segment[0].prev_location,
                polygons,
            });
        }

        deleteSegment(id)
            .then(() => {
                dispatch(panelLayoutV2Actions[DELETE_SEGMENT_SUCCESS]());
                const filteredSegments = segments
                    .filter((current) => current.id !== id)
                    .map((current) => ({ ...current, open: false }));

                dispatch(updateSegments(filteredSegments));
                showToast({ body: i18next.t('Segment has been removed') });

                if (segment[0].type === POLYGON_SEGMENT) {
                    const panels = filteredSegments
                        .filter((segment) => segment.type === POLYGON_SEGMENT)
                        .map((segment) => segment.panel);

                    dispatch(
                        panelLayoutV2Actions[FETCH_OFFER_PANELS_SUCCESS]({
                            panels,
                        }),
                    );
                }

                if (callback) callback(id);

                if (prevCollidedPolygons.length > 0) {
                    prevCollidedPolygons.forEach((segment) => {
                        const { id, polygon } = segment;
                        const config = {
                            segmentId: id,
                            callback: checkCallback,
                            callbackError: checkCallbackError,
                            commercialOfferId,
                            google,
                            mapValue,
                            polygon,
                        };

                        dispatch(checkSegment(config));
                    });
                }
            })
            .catch((error) => {
                dispatch(
                    panelLayoutV2Actions[DELETE_SEGMENT_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
                showReponseErrorsAsAlert(dispatch, error.response);
            });
    };
